import React from 'react';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { Typography } from '@guildeducationinc/recess';
import { employerIds } from '@src/constants/employerResources';
import { ScreenProps } from 'src/containers/QuizContainer/types';
import { Footer } from 'src/components/Quiz/Footer';
import { CelebrateIcon } from 'src/components/Quiz/Icons/CelebrateIcon';
import styles from './TuitionInfo.module.scss';

export const TuitionInfo: React.FC<ScreenProps> = props => {
	const { userFromIdToken: authUser } = useMemberExperienceAuth();

	let message: string;
	if (authUser?.employer_uuid === employerIds.disney) {
		message =
			"In case you didn't know, Disney pays 100% of your tuition, so you can focus on your classes and career.";
	} else if (authUser?.employer_uuid === employerIds.walmart) {
		message =
			'With Live Better U, you can go back to school and Walmart will pay 100% - that means you pay no tuition or mandatory fees.';
	} else {
		props.nextScreen();
		return null;
	}

	return (
		<div className={styles.container}>
			<CelebrateIcon size={126} />
			<Typography className={styles.title} variant='h1'>
				{message}
			</Typography>
			<Footer onClickNext={props.nextScreen} onClickPrevious={props.previousScreen} />
		</div>
	);
};
